<template>
  <div @click="toggleActive(); $emit('click-filter-btn');" v-bind:class="[isActive ? 'active-button' : 'inactive-button']">
    <p class="button-text">{{title}}</p>
    <img class="button-img" :src="isActive ? checkMark : plusSign" />
  </div>
</template>

<style lang="scss">
.spaced {
  margin-left: 4px;
}
.inactive-button {
  display: flex;
  background: #ffffff;
  border: 1px solid #bebebe;
  margin: 3px;
  box-sizing: border-box;
  border-radius: 3px;
  height: 48px;
}

.active-button {
  display: flex;
  background: #efefef;
  border: 1px solid #000000;
  margin: 3px;
  box-sizing: border-box;
  border-radius: 3px;
  height: 48px;
}

.button-text {
  padding-left: 16px;
  padding-top: 7px;
  padding-bottom: 8px;
  width: fit-content;
  font-family: Avenir;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 33px;
  color: #000000;
  pointer-events: none;
}

.button-img {
  padding-left: 12px;
  padding-right: 18px;
  align-self: center;
}
</style>

<script>
import plusSign from '@/assets/plus.svg'
import checkMark from '@/assets/checkmark.svg'

export default {
  name: 'filterButton',
  data () {
    return {
      isActive: false,
      plusSign: plusSign,
      checkMark: checkMark
    }
  },
  methods: {
    toggleActive: function () {
      this.isActive = !this.isActive
    }
  },
  props: {
    title: String
  }
}
</script>
